/**
 * First we will load all of this project's JavaScript dependencies which
 * includes React and other helpers. It's a great starting point while
 * building robust, powerful web applications using React + Laravel.
 */

import PosApp from './pos/PosApp';

/**
 * Next, we will create a fresh React component instance and attach it to
 * the page. Then, you may begin adding components to this application
 * or customize the JavaScript scaffolding to fit your unique needs.
 */
import React from 'react';
import { createRoot } from 'react-dom/client';

const root = document.getElementById('app');
if (root) {
    const Index = createRoot(root);
    const App = PosApp();
    Index.render(React.createElement(App));
}
